// main.js

import ThemeManager from "./modules/theme";
import StickyHeader from "./modules/stickyheader";
import CTAScrollToAnchor from "./modules/cta-scroll-to-anchor";

document.addEventListener("DOMContentLoaded", () => {
  // Inizializza il tema al caricamento della pagina
  ThemeManager.initializeTheme();
  // Ascolta i cambiamenti delle preferenze di sistema
  ThemeManager.watchSystemPreferences();
  // Collega l'event listener al pulsante toggle
  ThemeManager.attachToggleListener("#icnThemeToggle");

  // Inizializza l'header sticky
  StickyHeader.initialize("mainSiteHeader", "wpadminbar");

  // HERO HOMEPAGE > Inizializza il pulsante CTA scroll-to-anchor
  CTAScrollToAnchor.initialize(
    "CTAScrollToAnchor",
    "inizioContenuto",
    "mainSiteHeader"
  );

  // Inizializza l'animazione del path SVG
  initializeSVGPathAnimations();
});

function initializeSVGPathAnimations(selector = ".path-animate") {
  const paths = document.querySelectorAll(selector); // selettore predefinito

  if (paths.length === 0) {
    console.warn(
      `[initializeSVGPathAnimations] Nessun elemento trovato con selettore "${selector}".  Probabilmente non è usato in questa pagina.`
    );
    return;
  }

  paths.forEach((path, index) => {
    try {
      const length = path.getTotalLength();
      console.log(`[SVG Path: ${selector} ${index}] Lunghezza: ${length}`);

      path.style.strokeDasharray = length;
      path.style.strokeDashoffset = length;
    } catch (error) {
      console.error(
        `[SVG Path: ${selector} ${index}] Errore nel calcolo della lunghezza:`,
        error
      );
    }
  });
}
